// =============================================================================
// Trial Banner - Non-dismissible banner showing trial status
// =============================================================================

import { useNavigate } from 'react-router-dom';
import { usePlanGate } from '@/hooks/usePlanGate';
import { Sparkles } from 'lucide-react';

export function TrialBanner() {
  const navigate = useNavigate();
  const { isPro, isTrialing, trialExpired, trialDaysRemaining, status, cancelPending } = usePlanGate();

  // Hide for paying Pro customers
  if (isPro && status === 'ACTIVE') return null;

  // No banner for cancel-pending (they're still Pro) or CANCELED (transitioning to FREE)
  if (cancelPending || status === 'CANCELED') return null;

  // Hide if no billing info (shouldn't happen, but safety)
  if (!isTrialing && !trialExpired) return null;

  const isUrgent = isTrialing && trialDaysRemaining <= 3;

  if (trialExpired) {
    return (
      <div className="bg-red-600 text-white px-4 py-2.5 text-center text-sm">
        <span className="font-medium">Your trial has ended.</span>{' '}
        Upgrade to Pro to create properties and use DocuSign.{' '}
        <button
          onClick={() => navigate('/settings?billing=upgrade')}
          className="underline font-semibold hover:no-underline ml-1"
        >
          Upgrade
        </button>
      </div>
    );
  }

  return (
    <div className={`${isUrgent ? 'bg-orange-500' : 'bg-gray-600'} text-white px-4 py-2.5 text-center text-sm`}>
      <Sparkles className="w-4 h-4 inline-block mr-1.5 -mt-0.5" />
      {isUrgent ? (
        <>
          <span className="font-medium">Your trial ends in {trialDaysRemaining} day{trialDaysRemaining !== 1 ? 's' : ''}!</span>{' '}
        </>
      ) : (
        <>
          You have <span className="font-medium">{trialDaysRemaining} days</span> left in your free trial.{' '}
        </>
      )}
      <button
        onClick={() => navigate('/settings?billing=upgrade')}
        className="underline font-semibold hover:no-underline ml-1"
      >
        Upgrade now
      </button>
    </div>
  );
}
